














import {Vue, Component} from 'vue-property-decorator'
import Orders from "./Orders.vue";
import Visits from "./Visits.vue";
import Messages from "./Messages.vue";
import Activities from "./Activities.vue";
import ActiveVisitsMap from "./ActiveVisitsMap.vue";
import Chart from "./Chart.vue";

@Component({components: {Activities, Visits, Orders, Messages, Chart, ActiveVisitsMap}})
export default class Dashboard extends Vue {
  created() {
  }
}
